module.exports = __webpack_public_path__ + "media/images/common/h3_cart-dd064e18d5e736b76085bf225dd017a0.gif";